import { createElement } from 'react';
import { ItemTypes } from '../Constants';
import { DragSource } from 'react-dnd';
import { store, ComponentDesc, ShelfComponentProps, ScreenComponentProps, SettingsComponentProps, getDefaultSettings, imageDefaultSettings } from '../store';
import { observer } from 'mobx-react';
import { flowRight } from 'lodash';
import MarginEditor from './common/MarginEditor';
import PaddingEditor from './common/PaddingEditor';
import BorderEdit from './common/BorderEdit';
import BorderRadius from './common/BorderRadius';
import ColorPicker from './common/ColorPicker';
import BackgroundColorPicker from './common/BackgroundColorPicker';

import { shelfComponentStyles, settingsComponentStyles } from './common/styles';
import withStyles from 'react-jss';

const svg = require('./icons/image.svg');
//const menu_button = require('./icons/menu_button.svg');

interface ImageSettings {
    src: string;
    height: number;
    width: number;
}

let defaultTemplate = {
    type: 'IMAGE',
    style: {
        ...imageDefaultSettings(),
    },
    settings: {
        src: 'https://via.placeholder.com/125x125',
        height: 30,
        width: 100,
    },
    name: 'Image',
};

const draggableShelfComponent = flowRight([
    withStyles(shelfComponentStyles),

    DragSource(
        ItemTypes.COMPONENT,
        {
            beginDrag(props: any): ComponentDesc<ImageSettings> {
                let t = JSON.parse(JSON.stringify(defaultTemplate));
                t.id = +new Date();
                return t;
            },
        },
        function collect(connect, monitor) {
            return {
                connectDragSource: connect.dragSource(),
                isDragging: monitor.isDragging(),
            };
        }
    ),
    observer,
])((props: ShelfComponentProps<typeof shelfComponentStyles>) => {
    let { connectDragSource, isDragging, classes } = props;
    return connectDragSource(
        <div className={classes.outer}>
            <div className={classes.section}>
                <img src={svg} className={classes.icon} />
                <span className={classes.label}>Image</span>
            </div>
        </div>
    );
});

const draggableScreenComponent = flowRight([observer])((props: ScreenComponentProps<ImageSettings>) => {
    let { descriptor } = props;
    return (
        <div
            style={{
                cursor: 'move',
                minHeight: '10px',

                ...descriptor.style,
            }}
            onClick={(e) => store.selectComponent(descriptor)}>
            <table>
                <tr>
                    <td>
                        <img className="imgScreen" src={descriptor.settings.src ? descriptor.settings.src : ''} height={descriptor.settings.height} width={descriptor.settings.width} />
                    </td>
                </tr>
            </table>
        </div>
    );
});

/**
 * Define the settings panel for this component
 * @type {({ descriptor }: any) => any}
 */

const SettingsComponent = flowRight([withStyles(settingsComponentStyles), observer])(function({ descriptor, classes }: SettingsComponentProps<ImageSettings, typeof settingsComponentStyles>) {
    return (
        <div>
            <div className={classes.root}>
                <div
                    style={{
                        display: 'flex',
                        flexDirection: 'column',
                        paddingBottom: 10,
                        marginTop: 10,
                    }}>
                    <div
                        style={{
                            display: 'flex',
                            paddingBottom: 5,
                            alignItems: 'center',
                        }}>
                        <span
                            className={classes.header}
                            style={{
                                width: 81,
                            }}>
                            Source
                        </span>
                        <input className={classes.src + ' imageSettingSrc'} type="text" value={descriptor.settings.src} onChange={(e) => (descriptor.settings.src = e.target.value)} />
                    </div>
                    <div
                        style={{
                            display: 'flex',
                            paddingBottom: 5,
                            paddingTop: 12,
                            alignItems: 'center',
                        }}>
                        <span
                            className={classes.header}
                            style={{
                                width: 81,
                            }}>
                            Height
                        </span>
                        <input className={classes.width_height + ' heightInputbox'} type="text" value={descriptor.settings.height} onChange={(e) => (descriptor.settings.height = +e.target.value)} />
                        <span
                            className={classes.header}
                            style={{
                                width: 48,
                                marginLeft: 16,
                            }}>
                            Width
                        </span>

                        <input className={classes.width_height + ' widthInputBox'} type="text" value={descriptor.settings.width} onChange={(e) => (descriptor.settings.width = +e.target.value)} />
                    </div>
                </div>
            </div>
            <div>
                <MarginEditor descriptor={descriptor} />
                <PaddingEditor descriptor={descriptor} />
                <BorderEdit descriptor={descriptor} />
                <BackgroundColorPicker descriptor={descriptor} />
            </div>
        </div>
    );
});

store.registerComponent({
    name: 'IMAGE',
    type: 'component',
    shelfComponent: draggableShelfComponent,
    screenComponent: draggableScreenComponent,
    settingsComponent: SettingsComponent,
    defaultTemplate,
    svg,
});

//export default withStyles(styles)(observer(component))
